import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC06BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_06, actualizarFC_06Estatus, actualizarFC_06Fecha,
    actualizarFileFC_06, agregarFileFC_06, eliminarFileFC_06

} from '../../../redux/DucksBeneficiario/FC_06Ducks';
import moment from 'moment'
import ArchivosPrediosViveros from '../../ArchivosComponents/ArchivosPrediosViveros';

const DocumentacionFC_06Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_06Solicitud.modoCorreccion)
    let dataDocumentacion = useSelector(store => store.FC_06Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesPredio = useSelector(store => store.FC_06Solicitud.filesPredios)
    const filesVivero = useSelector(store => store.FC_06Solicitud.filesViveros)
    let filesMap = useSelector(store => store.FC_06Solicitud.filesMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)
    const opcionesFilesPredios = useSelector(store => store.FC_06Solicitud.opcionesFilePredio)
    const opcionesFilesViveros = useSelector(store => store.FC_06Solicitud.opcionesFileVivero)
    const [folio, setFolio] = React.useState('')
    let filesViverosMap = useSelector(store => store.FC_06Solicitud.filesViverosMap)
    let filesPrediosMap = useSelector(store => store.FC_06Solicitud.filesPrediosMap)
    const obtenerNumeroDeFiles = async () => {
        const countArchivos = await contadorPrediosViveros()
        const totalFilesPredios = (filesPredios.filter(file => file.estatus === true)).length
        const totalFilesViveros = (filesViveros.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesPredios + totalFilesViveros

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc06_registromaguey: dataDocumentacion.idfc06_registromaguey }
            await dispatch(actualizarFC_06Fecha(solicitud))
            setFolio(dataDocumentacion.folio)
            const idSolicitud = dataDocumentacion.idfc06_registromaguey
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_06 = 2
            const tabla = tablaFC_06
            await dispatch(actualizarFC_06Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: dataDocumentacion.folio } }
            ))
            await dispatch(resetDataFC_06())
            setEnvioCorrecto(true)
        }
    }
    const contadorPrediosViveros = () => {
        let contador = 0
        if (dataDocumentacion.fc_06_anexovivero.length > 0 && dataDocumentacion.vivero) {
            for (const i in opcionFileVivero) {
                if (opcionFileVivero[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFileVivero[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFileVivero[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFileVivero[i].opcionFile === 'contratocompraventa') contador += 3
            }
            if (opcionFileVivero.length !== dataDocumentacion.fc_06_anexovivero.length) contador++
        }
        if (dataDocumentacion.fc_06_anexopredio.length > 0 && dataDocumentacion.predio) {
            // contador += productor.length
            for (const i in opcionFilePredio) {
                if (opcionFilePredio[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFilePredio[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFilePredio[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFilePredio[i].opcionFile === 'contratocompraventa') contador += 3
            }
            if (opcionFilePredio.length !== dataDocumentacion.fc_06_anexopredio.length) contador++
        }
        return contador
    }


    React.useEffect(() => {
        if (filesPredio?.data) {
            let newFiles = []
            for (const file in filesPredio?.data) {
                const { ...newFile } = filesPredio?.data?.[file]
                newFiles.push(newFile)
            }
            setFilePredios(newFiles)
        }
    }, [dataDocumentacion])
    React.useEffect(() => {
        if (filesVivero?.data) {
            let newFiles = []
            for (const file in filesVivero.data) {
                const { ...newFile } = filesVivero.data?.[file]
                newFiles.push(newFile)
            }
            setFileViveros(newFiles)
        }
    }, [dataDocumentacion])

    React.useEffect(() => {
        if (opcionesFilesViveros) {
            let newOpciones = []
            for (const opcion of opcionesFilesViveros) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileVivero(newOpciones)
        }
        if (opcionesFilesPredios) {
            let newOpciones = []
            for (const opcion of opcionesFilesPredios) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFilePredio(newOpciones)
        }
    }, [])

    //FILES VIVEROS
    const [filesViveros, setFileViveros] = React.useState([])
    const handdleFileVivero = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_06/agregarNuevoFC_06AnexosArchivosViveros'
        }
        const result = await dispatch(agregarFileFC_06(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosvivero
            objectFile.estatus = true
            setFileViveros(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevVivero = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesViveros.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_06/actualizarFormatoFC06_AnexosArchivosViveros'
                }
                const result = await dispatch(actualizarFileFC_06(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_06/agregarNuevoFC_06AnexosArchivosViveros'
                    }
                    result = await dispatch(agregarFileFC_06(data))
                }
                if (result.payload.data?.data) {
                    setFileViveros(newFiles)
                    return true
                } else {
                    const newFiles = filesViveros.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileViveros(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFileVivero, setOpcionFileVivero] = React.useState([])
    const handleChangeOptionFileVivero = (option) => {
        setOpcionFileVivero(prev => [...prev, option])
    }
    const handdleRemoveOptionFileVivero = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileVivero.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileVivero(newOptions)
            }
        }
    }
    const deletePrevVivero = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_06/eliminarArchivoVivero'
                    }
                    await dispatch(eliminarFileFC_06(data))
                }
            })
            setFileViveros(newFiles)
        }
    }
    //FILES PREDIOS
    const [filesPredios, setFilePredios] = React.useState([])
    const handdleFilePredio = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_06/agregarNuevoFC_06AnexosArchivosPredios'
        }
        const result = await dispatch(agregarFileFC_06(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivospredio
            objectFile.estatus = true
            setFilePredios(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevPredio = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesPredios.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_06/actualizarFormatoFC06_AnexosArchivosPredios'
                }
                const result = await dispatch(actualizarFileFC_06(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_06/agregarNuevoFC_06AnexosArchivosPredios'
                    }
                    result = await dispatch(agregarFileFC_06(data))
                }
                if (result.payload.data?.data) {
                    setFilePredios(newFiles)
                    return true
                } else {
                    const newFiles = filesPredios.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilePredios(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFilePredio, setOpcionFilePredio] = React.useState([])
    const handleChangeOptionFilePredio = (option) => {
        setOpcionFilePredio(prev => [...prev, option])
    }
    const handdleRemoveOptionFilePredio = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFilePredio.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFilePredio(newOptions)
            }
        }
    }
    const deletePrevPredio = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_06/eliminarArchivoPredio'
                    }
                    await dispatch(eliminarFileFC_06(data))
                }
            })
            setFilePredios(newFiles)
        }
    }

    const viveristaPredioFiles = () => {
        let nameDocumentacion = ''
        if (dataDocumentacion?.vivero) nameDocumentacion = 'viverista'
        if (dataDocumentacion?.predio && dataDocumentacion?.vivero) nameDocumentacion += '/productor maguey'
        else if (dataDocumentacion?.predio) nameDocumentacion = 'productor maguey'
        return (
            <div>
                <Collapsible trigger={`Agregar documentación de ${nameDocumentacion}`} className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        {
                            dataDocumentacion?.fc_06_anexovivero?.map((vivero, index) => (
                                <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                    <ArchivosPrediosViveros api={{ handdleFile: handdleFileVivero, handdleRemovePrev: handdleRemovePrevVivero, files: filesViveros }} idAnexoFK={vivero.idfc06_anexovivero}
                                        id={`VIV${vivero.idfc06_anexovivero}`} tabla={"FC_06_anexos"} anexo={vivero} name='Vivero' tipo={'Vivero'}
                                        opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }} filesMap={filesViverosMap} />
                                </div>
                            ))
                        }
                        {
                            dataDocumentacion?.fc_06_anexopredio?.map((predio, index) => (
                                <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                    <ArchivosPrediosViveros api={{ handdleFile: handdleFilePredio, handdleRemovePrev: handdleRemovePrevPredio, files: filesPredios }} idAnexoFK={predio.idfc06_anexopredio}
                                        id={`PRED${predio.idfc06_anexopredio}`} tabla={"FC_06_anexos"} anexo={predio} name='Predio' tipo={'Predio'}
                                        opcionSelect={{ handleChangeOptionFile: handleChangeOptionFilePredio, opcion: opcionFilePredio, handdleRemoveOptionFile: handdleRemoveOptionFilePredio, deletePrevFile: deletePrevPredio }} filesMap={filesPrediosMap} />
                                </div>
                            ))
                        }
                    </div>
                </Collapsible>

            </div>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {viveristaPredioFiles()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envío</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_06Component)
